'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "SecondaryAction": "Polaris-ActionMenu-SecondaryAction",
  "critical": "Polaris-ActionMenu-SecondaryAction--critical"
};

exports.default = styles;
